import { Star } from "lucide-react";

export function VipBadge({ show, testid }) {
  if (!show) return null;
  return (
    <span
      className="inline-flex items-center gap-0.5 text-[9px] font-bold tracking-luxe px-1.5 py-0.5 rounded-full"
      style={{
        background: "#D4AF3720",
        color: "#8B6914",
        border: "1px solid #D4AF37",
      }}
      aria-label="VIP guest"
      title="VIP"
      data-testid={testid || "vip-badge"}
    >
      <Star className="w-2.5 h-2.5" fill="#D4AF37" strokeWidth={0} aria-hidden />
      VIP
    </span>
  );
}
